"use client";

import { ArrowLeft } from "lucide-react";
import { Button } from "./buttons/button";
import { Typography } from "./typography";

type HeaderBackButtonProps = {
  onBack: () => void;
  title?: string;
};

/**
 * A header-specific back button designed to be used as children of CreatorMobileHeaderReturn.
 * Provides consistent styling and includes the grow spacer for proper header layout.
 */
export const HeaderBackButton = ({ onBack, title }: HeaderBackButtonProps) => (
  <div className="flex w-full max-w-56 flex-row gap-2 px-2 sm:px-1!">
    <Button
      variant="text"
      size="lg"
      onClick={onBack}
      className="h-3 w-fit justify-start"
      aria-label="Go back"
      icon={ArrowLeft}
    />

    {/* Title */}
    <Typography
      className="w-full cursor-pointer text-lg leading-3 select-none"
      weight="semibold"
      onClick={onBack}
    >
      {title}
    </Typography>
  </div>
);
